import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Button from "../../components/Buttons/button";
import { Logo } from "../../assets/imageAssets";
import TextLink from "../../components/Buttons/textLink";
import { AlignJustify } from "@untitledui/icons/AlignJustify";
import { User01 } from "@untitledui/icons/User01";
import { LogOut01 } from "@untitledui/icons/LogOut01";
import { XClose } from "@untitledui/icons/XClose";
import { openModals } from "../../redux/modal.slice";
import ModalsEnum from "../../enums/modal.enum";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { setMeData } from "../../redux/me.slice";
import { removeAuthToken } from "../../utils/authToken";

const Header = () => {
  const location = useLocation();
  const navigation = useNavigate();
  const user = useSelector(state => state.me?.data);
  console.log("user", user);

  const pathname = location.pathname;
  const dispatch = useDispatch();
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const handleBurgerMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const handleSignIn = () => {
    dispatch(
      openModals({
        modalIds: [ModalsEnum.SIGN_IN_MODAL],
      }),
    );
  };

  const logout = () => {
    dispatch(setMeData(null));
    removeAuthToken();
  };

  const handleUserDropdown = () => setDropdownOpen(!dropdownOpen);
  const goProfilePage = () => {
    setDropdownOpen(!dropdownOpen);
    navigation("/profile");
  };

  return (
    <div className="header">
      <div className="container">
        {pathname !== "/reset-password" ? (
          <div className="header__content flex flex-align-center flex-between">
            <div className="header__left flex flex-align-center">
              <div className="logo mr-40">
                <Link to={"/"}>
                  <img src={Logo} alt="" />
                </Link>
              </div>
              {/* <nav className={`${menuOpen ? "open" : ""}`}>
                <ul className="navbar flex flex-align-center">
                  <li>
                    <TextLink text={"Profiles"} />
                  </li>
                  <li>
                    <TextLink text={"News & Reports"} />
                  </li>
                  <li>
                    <TextLink text={"Pricing"} />
                  </li>
                  <li>
                    <TextLink text={"Contact"} />
                  </li>
                </ul>
              </nav> */}
            </div>
            <div className="header__right flex flex-align-center">
              {/* Logged in case */}
              {user?.id ? (
                <div className="user-box">
                  <button className={`user-dropdown-button flex flex-align-center flex-justify-center ${dropdownOpen ? "active" : ""}`} onClick={handleUserDropdown}>
                    {user?.username.slice(0, 2)}
                  </button>
                  {dropdownOpen && (
                    <ul className="user-dropdown">
                      <li className="user-dropdown__item flex flex-align-center">
                        <span> {user?.username.slice(0, 2)}</span>
                        <div>
                          <div className="user-name">{user?.username}</div>
                          <div className="user-email">{user?.email}</div>
                        </div>
                      </li>
                      <li className="user-dropdown__item">
                        <button className="flex flex-align-center" onClick={goProfilePage}>
                          <User01 />
                          View profile
                        </button>
                      </li>
                      <li className="user-dropdown__item">
                        <button className="flex flex-align-center" onClick={logout}>
                          <LogOut01 />
                          Log out
                        </button>
                      </li>
                    </ul>
                  )}
                </div>
              ) : (
                <Button text={"Sign In"} onClick={handleSignIn} />
              )}

              <button className="burger-menu-button" onClick={handleBurgerMenu}>
                {menuOpen ? <XClose /> : <AlignJustify />}
              </button>
            </div>
          </div>
        ) : (
          <div className="header__content flex flex-align-center flex-justify-center">
            <div className="logo">
              <Link to={"/"}>
                <img src={Logo} alt="" />
              </Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Header;
